module.exports = __webpack_public_path__ + "img/gallery_pic6-compressed.235de0c3.jpg";